import React from "react";
import cx from "classnames";
import styles from "../scss/AppForm.module.scss";
import Icon from "../../common/components/Icon/Icon";

const AFSecure: React.FC = () => {
    return (
        <div>
            <div className={"layout-flex-viewport-conditional desktop"}>
                <Icon
                    alt="Secure Icon"
                    size="3xl"
                    className={cx(styles["icon"], "space-s")}
                    id="SecureCircle"
                />
                <strong>Secure</strong>
            </div>

            <div className={"layout-flex-viewport-conditional mobile"}>
                <Icon
                    alt="Secure Icon"
                    size="ml"
                    className={cx(styles["icon"], "layout-flex-self-center space-s")}
                    id="Secure"
                />
                <strong>Secure</strong>
            </div>
        </div>
    );
};

export default AFSecure;
